import flatten from 'lodash/flatten';
import sortBy from 'lodash/sortBy';
import { DateTime } from 'luxon';
import { getIdentifier } from '~/mst/utils';
import type { IReportsStore } from '~/mst/models/reports';
import type { IReport } from '~/mst/models/report';
import { collectTags } from '~/utils/tags';
import { getCounts, getFilterOptions } from '~/mst/models/abstract/filterable/actions';
import { ReportRunTypes, ReportTypes } from '../report/types';

export default (self: IReportsStore) => {
  return {
    /** Unique, sorted pool of tags authored in the descriptions of these reports. */
    get tags(): string[] {
      return collectTags(self.toArray.map((report: IReport) => report.description));
    },
    // Custom items list for the reporting-period group so months sort by date with
    // the most recent first, rather than alphabetically (the Filterable default).
    get getReportingPeriodFiltersItemsList() {
      const tagsList = getCounts(flatten(self.filteredModels.map((report: IReport) => report.reportingPeriodFilterTags).filter(Boolean)));
      const options = getFilterOptions(tagsList, 'reporting-period');
      return sortBy(options, (option) => -DateTime.fromFormat(option.title, 'LLLL yyyy').toMillis());
    },
    get filteredList() {
      return self.filteredModels.map((report: IReport) => ({
        id: getIdentifier(report),
        name: report.name,
        type:
          report.configuration.type === 'aqi_basic' || report.configuration.type === 'aqi_extended'
            ? ReportTypes.air_quality
            : report.configuration.type,
        date_from: report.configuration.date_from,
        date_to: report.configuration.date_to,
        date_range: report.configuration.date_range,
        working_hours: report.configuration.working_hours,
        frequency: report.configuration.frequency,
        run_type: report.run_type,
        next_email_sent_at: report.next_email_sent_at,
        time_zone: report.configuration.time_zone,
        description: report.description,
        created_at: report.created_at,
        jobStatusError: report.jobStatusError,
        isExpandable: report.run_type === ReportRunTypes.scheduled
      }));
    }
  };
};
